import { SoftwareAddonTemplate } from "../../../lib/model/addonTemplate";
import apl from "../../images/templates/a-pilots-life.png";

export const aPilotsLifeTemplate: SoftwareAddonTemplate = {
  type: "software",
  id: "aPilotsLife",
  title: "A Pilot's Life",
  platforms: ["msfs", "xplane", "p3d", "fsx"],
  image: apl,
  content: [
    {
      title: "Simulator Setup",
      roles: [
        "flightPlanning",
        "beforeSimFlightStart",
        "beforeSimStart",
        "cockpitPreparation",
        "beforeFlightStart",
        "beforePushback",
      ],
      content: [
        { item: "SimBrief Flight Plan", setting: "Dispatched" },
        { item: "APL Aircraft Type", setting: "Set" },
        { item: "APL Cruise Altitude", setting: "Set" },
      ],
    },
    {
      title: "Cruise",
      roles: ["cruise", "climbOut"],
      content: [{ item: "APL Cruise Altitude", setting: "Checked" }],
    },
    {
      title: "Parking",
      roles: ["parking", "shutdown", "securing", "afterSimShutdown"],
      content: [{ item: "APL Flight", setting: "Submitted" }],
    },
  ],
};
